import React from 'react';
import PropTypes from 'prop-types';

import ResultsFrom from '../ResultsFrom';
import ResultEditButtons from '../ResultsFrom/ResultEditButtons';

import './AlertRightBlock.scss';

export default function AlertRightBlock(props) {
  const { type } = props;

  return <div className="alert-right-block">{type === 'header' ? <ResultsFrom {...props} /> : <ResultEditButtons {...props} />}</div>;
}

AlertRightBlock.propTypes = {
  type: PropTypes.string.isRequired,
};
